import * as yup from 'yup'

const schema = yup.object().shape({
  email: yup.string().email(),
  emailList: yup.array().of(yup.string().email()),
})

export default schema
